import Text from './text';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import { TextProps } from './text.types';
import useGetColorForProjectThemeComponents from '@/utils/colors/use-get-color-for-project-theme-components';

interface ProjectColorTextProps extends TextProps {
  colorVariable?: EColorVariablesV2;
  contrastAgainstAppBackground?:
    | boolean
    | { colorToChange: EColorVariablesV2; colorToContrastAgainst: EColorVariablesV2 };
  includeOpacity?: boolean;
}

/*
 * ProjectColorText is a Text component that renders text with a color
 * from the working project's theme colors, defaulting to the primary color, allowing for automatic contrast
 * adjustment against the app's background color.
 */
const ProjectColorText = ({
  children,
  colorVariable,
  contrastAgainstAppBackground,
  color: colorProp,
  includeOpacity,
  'data-component': dataComponent,
  ...rest
}: ProjectColorTextProps) => {
  const { hex, opacity } = useGetColorForProjectThemeComponents({
    colorVariable,
    contrastAgainstAppBackground,
  });

  return (
    <Text
      /*
				Note: passing in color prop will override the calculated project theme color.
				If your intention is just use a prop and not need the project theme,
				then just directly use the Text component instead of ProjectColorText.
			*/
      color={colorProp || hex}
      opacity={includeOpacity ? opacity : 1}
      data-component={dataComponent || 'ProjectColorText'}
      {...rest}
    >
      {children}
    </Text>
  );
};

export default ProjectColorText;
